module.exports = __webpack_public_path__ + "img/off.3f7b282.svg";